// import React, { useState, useEffect, useCallback } from 'react';
// import { getContacts, markContactRead, deleteContact } from '../utils/api';
// import toast from 'react-hot-toast';

// export default function ContactsPage() {
//   const [contacts, setContacts] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [filter, setFilter] = useState('all');
//   const [selected, setSelected] = useState(null);
//   const [page, setPage] = useState(1);
//   const [total, setTotal] = useState(0);

//   const fetch = useCallback(() => {
//     setLoading(true);
//     const params = { page, limit: 15 };
//     if (filter === 'unread') params.isRead = false;
//     if (filter === 'read') params.isRead = true;
//     getContacts(params)
//       .then(r => { setContacts(r.data.data); setTotal(r.data.total); })
//       .catch(() => toast.error('Failed to load'))
//       .finally(() => setLoading(false));
//   }, [page, filter]);

//   useEffect(() => { fetch(); }, [fetch]);

//   const handleSelect = async (contact) => {
//     setSelected(contact);
//     if (!contact.isRead) {
//       try {
//         await markContactRead(contact._id);
//         setContacts(p => p.map(c => c._id === contact._id ? { ...c, isRead: true } : c));
//       } catch {}
//     }
//   };

//   const handleDelete = async (id) => {
//     if (!window.confirm('Delete this message?')) return;
//     try {
//       await deleteContact(id);
//       toast.success('Message deleted');
//       if (selected?._id === id) setSelected(null);
//       fetch();
//     } catch { toast.error('Failed'); }
//   };

//   return (
//     <div className="space-y-5">
//       <div>
//         <h1 className="font-display text-xl font-semibold text-surface-100">Contact Messages</h1>
//         <p className="text-surface-500 text-sm mt-0.5">{total} messages received</p>
//       </div>

//       <div className="flex gap-2">
//         {['all', 'unread', 'read'].map(f => (
//           <button key={f} onClick={() => { setFilter(f); setPage(1); }}
//             className={`px-3 py-1.5 rounded text-xs font-medium capitalize transition-colors ${filter === f ? 'bg-brand-400 text-surface-900' : 'bg-surface-700 text-surface-400 hover:text-surface-200'}`}>
//             {f}
//           </button>
//         ))}
//       </div>

//       <div className="grid grid-cols-1 lg:grid-cols-3 gap-5">
//         {/* Messages list */}
//         <div className="lg:col-span-2 card overflow-hidden">
//           <div className="divide-y divide-surface-700">
//             {loading ? (
//               [...Array(6)].map((_, i) => <div key={i} className="p-4 h-16 animate-pulse bg-surface-700/20" />)
//             ) : contacts.length === 0 ? (
//               <div className="p-12 text-center text-surface-600 text-sm">No messages found</div>
//             ) : contacts.map(c => (
//               <div key={c._id}
//                 className={`p-4 cursor-pointer hover:bg-surface-700/30 transition-colors ${selected?._id === c._id ? 'bg-surface-700/50 border-l-2 border-brand-400' : ''} ${!c.isRead ? 'bg-brand-400/5' : ''}`}
//                 onClick={() => handleSelect(c)}>
//                 <div className="flex items-start justify-between gap-2">
//                   <div className="flex-1 min-w-0">
//                     <div className="flex items-center gap-2">
//                       {!c.isRead && <span className="w-2 h-2 rounded-full bg-brand-400 flex-shrink-0" />}
//                       <p className={`text-sm font-medium truncate ${c.isRead ? 'text-surface-300' : 'text-surface-100'}`}>{c.name}</p>
//                     </div>
//                     {c.subject && <p className="text-surface-500 text-xs mt-0.5 truncate">{c.subject}</p>}
//                     <p className="text-surface-600 text-xs mt-0.5 truncate">{c.message?.slice(0, 60)}…</p>
//                   </div>
//                   <p className="text-surface-600 text-xs flex-shrink-0">{new Date(c.createdAt).toLocaleDateString('en-IN')}</p>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>

//         {/* Message detail */}
//         <div className="card p-5">
//           {selected ? (
//             <div className="space-y-4">
//               <div>
//                 <p className="text-surface-200 font-semibold">{selected.name}</p>
//                 <a href={`mailto:${selected.email}`} className="text-brand-400 text-sm hover:underline">{selected.email}</a>
//                 {selected.phone && <p className="text-surface-500 text-xs mt-0.5">{selected.phone}</p>}
//               </div>
//               {selected.subject && (
//                 <div>
//                   <p className="text-surface-500 text-xs uppercase tracking-wide mb-1">Subject</p>
//                   <p className="text-surface-300 text-sm font-medium">{selected.subject}</p>
//                 </div>
//               )}
//               <div>
//                 <p className="text-surface-500 text-xs uppercase tracking-wide mb-1">Message</p>
//                 <p className="text-surface-300 text-sm bg-surface-700/50 p-3 rounded leading-relaxed whitespace-pre-wrap">{selected.message}</p>
//               </div>
//               <p className="text-surface-600 text-xs">{new Date(selected.createdAt).toLocaleString('en-IN')}</p>
//               <div className="flex gap-2">
//                 <a href={`mailto:${selected.email}?subject=Re: ${encodeURIComponent(selected.subject || 'Your Enquiry')}`}
//                   className="btn-primary flex-1 text-center py-2 text-xs">Reply via Email</a>
//                 <button onClick={() => handleDelete(selected._id)} className="btn-danger py-2 px-3 text-xs">✕</button>
//               </div>
//             </div>
//           ) : (
//             <div className="h-48 flex items-center justify-center text-surface-600 text-sm">Select a message to read</div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }
import React, { useState, useEffect, useCallback } from 'react';
import { Search, Trash2, Mail, Phone, CheckCircle, Circle, MessageSquare } from 'lucide-react';
import { getAdminContacts, markContactRead, deleteContact } from '../utils/api';
import toast from 'react-hot-toast';
import ConfirmModal from '../components/ConfirmModal';

export default function ContactsPage() {
  const [contacts, setContacts] = useState([]);
  const [meta, setMeta] = useState({});
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);
  const [deleteId, setDeleteId] = useState(null);
  const [expanded, setExpanded] = useState(null);

  const fetchContacts = useCallback(async () => {
    setLoading(true);
    try {
      const res = await getAdminContacts({ search, page, per_page: 15 });
      setContacts(res.data.data || []);
      setMeta(res.data.meta || {});
    } catch { toast.error('Failed to load contacts'); }
    finally { setLoading(false); }
  }, [search, page]);

  useEffect(() => {
    const t = setTimeout(fetchContacts, search ? 400 : 0);
    return () => clearTimeout(t);
  }, [fetchContacts]);

  const handleMarkRead = async (id) => {
    try {
      await markContactRead(id);
      setContacts(prev => prev.map(c => c.id === id ? { ...c, is_read: true } : c));
    } catch { toast.error('Failed to update'); }
  };

  const handleDelete = async () => {
    try {
      await deleteContact(deleteId);
      toast.success('Contact deleted');
      setDeleteId(null);
      fetchContacts();
    } catch { toast.error('Failed to delete'); }
  };

  const unread = contacts.filter(c => !c.is_read).length;

  return (
    <div>
      <div className="mb-6">
        <h1 className="text-xl font-semibold text-white">Contacts</h1>
        <p className="text-white/40 text-sm mt-0.5">
          {unread > 0 ? <span className="text-blue-400">{unread} unread messages</span> : 'All messages read'} · {meta.total || 0} total
        </p>
      </div>

      <div className="card p-4 mb-4">
        <div className="relative max-w-sm">
          <Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-white/30" />
          <input value={search} onChange={e => { setSearch(e.target.value); setPage(1); }} placeholder="Search contacts..." className="input pl-9 py-2" />
        </div>
      </div>

      <div className="space-y-2">
        {loading ? (
          [...Array(6)].map((_, i) => <div key={i} className="card p-4"><div className="skeleton h-4 w-full rounded mb-2" /><div className="skeleton h-3 w-2/3 rounded" /></div>)
        ) : contacts.length === 0 ? (
          <div className="card p-12 text-center">
            <MessageSquare size={32} className="mx-auto mb-3 text-white/10" />
            <p className="text-white/30 text-sm">No contacts yet</p>
          </div>
        ) : (
          contacts.map(c => (
            <div key={c.id} className={`card overflow-hidden ${!c.is_read ? 'border-blue-500/20' : ''}`}>
              <div
                className="flex items-center justify-between p-4 cursor-pointer hover:bg-white/2 transition-colors"
                onClick={() => {
                  setExpanded(expanded === c.id ? null : c.id);
                  if (!c.is_read) handleMarkRead(c.id);
                }}
              >
                <div className="flex items-center gap-3 min-w-0">
                  {!c.is_read
                    ? <Circle size={8} className="text-blue-400 fill-blue-400 shrink-0" />
                    : <Circle size={8} className="text-white/15 shrink-0" />
                  }
                  <div className="min-w-0">
                    <div className="flex items-center gap-2">
                      <span className="font-medium text-white text-sm">{c.name}</span>
                      {!c.is_read && <span className="badge bg-blue-500/10 text-blue-400 text-[10px]">New</span>}
                    </div>
                    <div className="text-xs text-white/30 mt-0.5">{c.subject || 'No subject'}</div>
                  </div>
                </div>
                <div className="flex items-center gap-3 ml-3 shrink-0">
                  <span className="text-white/20 text-xs hidden sm:block">
                    {new Date(c.created_at).toLocaleDateString('en-IN')}
                  </span>
                </div>
              </div>

              {expanded === c.id && (
                <div className="border-t border-white/8 p-4 bg-surface-700/30">
                  <div className="flex flex-wrap gap-3 mb-4">
                    <a href={`mailto:${c.email}`} className="flex items-center gap-1.5 text-sm text-white/60 hover:text-white">
                      <Mail size={12} className="text-primary-400" /> {c.email}
                    </a>
                    {c.phone && (
                      <a href={`tel:${c.phone}`} className="flex items-center gap-1.5 text-sm text-white/60 hover:text-white">
                        <Phone size={12} className="text-primary-400" /> {c.phone}
                      </a>
                    )}
                  </div>

                  <div className="bg-surface-800 rounded-lg p-4 mb-4">
                    <p className="text-white/70 text-sm leading-relaxed">{c.message}</p>
                  </div>

                  <div className="flex items-center gap-2">
                    {!c.is_read && (
                      <button onClick={() => handleMarkRead(c.id)} className="btn-secondary py-1 px-3 text-xs">
                        <CheckCircle size={12} /> Mark as Read
                      </button>
                    )}
                    <a href={`mailto:${c.email}`} className="btn-primary py-1 px-3 text-xs">
                      <Mail size={12} /> Reply
                    </a>
                    <button onClick={() => setDeleteId(c.id)} className="btn-danger py-1 px-2 text-xs ml-auto">
                      <Trash2 size={11} /> Delete
                    </button>
                  </div>
                </div>
              )}
            </div>
          ))
        )}
      </div>

      {meta.last_page > 1 && (
        <div className="flex justify-center gap-2 mt-4">
          <button onClick={() => setPage(p => Math.max(1, p - 1))} disabled={page === 1} className="btn-secondary py-1 px-3 text-xs disabled:opacity-40">Prev</button>
          <span className="text-white/40 text-xs self-center">{meta.current_page} / {meta.last_page}</span>
          <button onClick={() => setPage(p => Math.min(meta.last_page, p + 1))} disabled={page === meta.last_page} className="btn-secondary py-1 px-3 text-xs disabled:opacity-40">Next</button>
        </div>
      )}

      <ConfirmModal open={!!deleteId} title="Delete Contact" message="Delete this contact message permanently?" onConfirm={handleDelete} onCancel={() => setDeleteId(null)} danger />
    </div>
  );
}